import { useCallback } from 'react';

import { FilterParamFactory, PaginatedEndpointBuilder } from '~/app/shared/table3tools/types';
import parsePagination from '~/app/shared/table3tools/utils/parsePagination';
import parseSorting from '~/app/shared/table3tools/utils/parseSorting';

export default function usePaginatedEndpointBuilder(
    endpoint: string,
    filterParamFactory: FilterParamFactory | undefined = undefined
): PaginatedEndpointBuilder {
    return useCallback(
        (pagination, sorting, filters) => {
            const paginationParams = parsePagination(pagination);
            const sortingParamsFragment = parseSorting(sorting);
            const filterParams = filterParamFactory?.(filters);

            const params = [paginationParams, sortingParamsFragment ? `sort=${sortingParamsFragment}` : undefined, filterParams]
                .filter(x => x !== undefined && x.trim() !== '')
                .join('&');
            return `${endpoint}?${params}`;
        },
        [endpoint, filterParamFactory]
    );
}
